import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select a branch.'), required)
      },
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a station name.'), required)
      },
      category_ids: {
        required: helpers.withMessage(i18n.global.t('Please select at least one category.'), required)
      },
      color: {},
      is_active: {}
    }
  }
};
